import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["OSSCards"] */ "/app/src/sections/oss-sponsored-by-develocity/cards/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeatureCards"] */ "/app/src/sections/oss-sponsored-by-develocity/feature-cards/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/sections/oss-sponsored-by-develocity/hero/hero-image-sm.png");
;
import(/* webpackMode: "eager" */ "/app/src/sections/oss-sponsored-by-develocity/hero/hero-image.png");
